export default __webpack_public_path__ + "static/media/Background_00149.baa3a2a6.png";